import { useMutation } from "@tanstack/react-query";
import {
  setCharactersFromText,
  textRecognizePosition,
} from "common/api/asocijator/topic/asocijator_topic_input_way_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseTextRecognizePositionParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
};

export const useTextRecognizePosition = (
  hookParams?: UseTextRecognizePositionParams
) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: textRecognizePositionMutate } = useMutation({
    mutationFn: async (params: any) =>
      await textRecognizePosition({
        topicId: params.topicId,
        startPosition: params.startPosition,
        deleteCount: params.deleteCount,
        add: params.add,
      }),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }
    },
  });

  return { textRecognizePositionMutate };
};
